import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';

import * as styles from './UserRelated.css';
import { AddOfferButton } from '../AddOfferButton';
import { LoginButton } from '../LoginButton';

interface IUserRelatedProps {
  gptButton: React.JSX.Element | null;
  userMenu: React.JSX.Element | null;
  utilities: React.JSX.Element;
  placeOfferLink: string | null;
  hasBlockedSanction: boolean;
  shouldShowNewPlacementText: boolean;
  addOfferButton: React.JSX.Element;
  onPlaceOfferClick(): void;
  onAuthenticateClick(): void;
}

export const UserRelated: React.FC<IUserRelatedProps> = ({
  gptButton,
  userMenu,
  utilities,
  placeOfferLink,
  hasBlockedSanction,
  shouldShowNewPlacementText,
  onPlaceOfferClick,
  onAuthenticateClick,
  addOfferButton,
}) => {
  return (
    <div className={styles['container']}>
      <Responsive desktop>{gptButton && <div className={styles['gpt-button']}>{gptButton}</div>}</Responsive>
      <Responsive phone>{addOfferButton}</Responsive>
      <Responsive desktop tablet>
        <div className={styles['utilities']}>{utilities}</div>
      </Responsive>
      <Responsive tablet desktop>
        {placeOfferLink && !hasBlockedSanction && (
          <div className={styles['place']}>
            <AddOfferButton
              type="desktop"
              href={placeOfferLink}
              onClick={onPlaceOfferClick}
              shouldShowNewPlacementText={shouldShowNewPlacementText}
            />
          </div>
        )}
        {userMenu || <LoginButton onAuthenticateClick={onAuthenticateClick} />}
      </Responsive>
    </div>
  );
};
